import React, { useState } from 'react';
import {
  Modal,
  Box,
  Typography,
  Button,
  IconButton,
  Stack
} from '@mui/material';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 380,
  height: 210,
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  p: 4,
  outline: 'none',
  textAlign: 'center',
  padding: '30px 45px',
};

const MissingKeyErrorModal = () => {
  const [open, setOpen] = useState(true);

  const handleClose = () => setOpen(false);

  return (
    <Modal
      open={open}
      onClose={() => {}}
      disableEscapeKeyDown
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      hideBackdrop
    >
      <Box sx={style}>
        <IconButton
          onClick={handleClose}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'grey.700',
          }}
        >
          <CloseIcon />
        </IconButton>

        <Stack direction="row" spacing={1} justifyContent="center" alignItems="center" sx={{ mb: 2 }}>
          <WarningRoundedIcon sx={{ color: 'red' }} />
          <Typography id="modal-title" variant="h6" sx={{ color: 'red', fontWeight: 700, fontSize: '20px' }}>
            Missing keys
          </Typography>
        </Stack>

        <Typography id="modal-description" sx={{ mb: 3, fontSize: '20px', lineHeight: '100%', marginBottom: '34px', marginTop: '27px' }}>
            Please select a key for each <br/> item
        </Typography>

        <Button variant="text" sx={{ fontSize: '20px', color: 'black' }} onClick={handleClose}>
          CLOSE
        </Button>
      </Box>
    </Modal>
  );
};

export default MissingKeyErrorModal;